var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9582 12L16.4791 9.53518M11.9582 12L7.47909 9.53518M11.9582 12L12 17M10.896 2.55904L4.00784 6.49455C3.38462 6.85062 3 7.51334 3 8.2311V15.7582C3 16.4817 3.39073 17.1487 4.02177 17.5026L11.0728 21.4566C11.6754 21.7945 12.4099 21.7975 13.0152 21.4643L19.9642 17.6403C20.6031 17.2888 21 16.6174 21 15.8881V8.2471C21 7.52081 20.6063 6.8516 19.9714 6.49884L12.8596 2.54733C12.2481 2.20756 11.5035 2.212 10.896 2.55904Z",
    stroke: "#1B202C",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.d71e4b5e02abca77909826c43425be3d.svg";
export { ForwardRef as ReactComponent };